import { useNavigate } from "react-router";

/**
 * Best-effort user id for any transaction / trade / request record.
 * Records carry an embedded user snapshot, otherwise the user is the sender
 * (debits) or the receiver (credits).
 */
export const getCustomerId = (record) =>
  record?.customer?.id ||
  record?.user?.id ||
  record?.user?._id ||
  (record?.trxType === "credit" ? record?.receiver : record?.sender);

/**
 * Customer name that opens the customer's details page from anywhere in the
 * admin. Stops click propagation so it works inside clickable table rows.
 */
const CustomerLink = ({ record, userId, children, className = "capitalize" }) => {
  const navigate = useNavigate();
  const id = userId || getCustomerId(record);
  const u = record?.customer || record?.user || {};
  const label =
    children ||
    [u.firstName, u.lastName].filter(Boolean).join(" ") ||
    u.email ||
    "View customer";

  if (!id) return <span className={className}>{label}</span>;

  return (
    <button
      type="button"
      title="View customer details"
      className={`text-[#4A4DE6] hover:underline text-left ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/customers/${id}`);
      }}
    >
      {label}
    </button>
  );
};

export default CustomerLink;
